import { ReactNode } from "react";
import { useSelector } from "react-redux";
import theme from "../../config/theme";

interface ContainerProps {
  children: ReactNode;
  header: string;
  border?: string;
}

export default function Container({ children, header }: ContainerProps) {
  const { theme: themeMode } = useSelector((state: any) => state.globalState);
  const mode = themeMode === "light" ? theme.light : theme.dark;

  return (
    <div
      className="flex flex-col items-start shadow md:p-8 p-3 rounded-md w-[98%] md:w-[95%] mx-auto md:mb-5 mb-3 first:mt-[90px] h-auto"
      style={{
        backgroundColor: mode.backgroundColor.bgSecondary,
        color: mode.color.textPrimary,
        border: "1px solid #E7E7E7",
        borderColor: mode.color.textSecondary,
      }}
    >
      <h2 className="font-semibold mb-5">{header}</h2>
      {children}
    </div>
  );
}
